module.exports = __webpack_public_path__ + "img/评论4_03.a6bc9f1d.jpg";